import axios from 'axios'

export function fetchData() {
  return axios.get('https://www.geld.tech/server-monitor-dashboard/server/usage/').then(response => { return response.data }).catch(error => { /* console.error(error); */ return Promise.reject(error) })
}

export function fetchSearchData(keyword) {
  return axios.get('https://www.geld.tech/server-monitor-dashboard/server/search/' + keyword).then(response => { return response.data }).catch(error => { /* console.error(error); */ return Promise.reject(error) })
}



// WEBPACK FOOTER //
// ./src/api/index.js